import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMeetingRoomList = createAsyncThunk("fetchMeetingRoomList", async ({ keyword, date, time, duration }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`meeting/room/list?keyword=${keyword}&date=${date}&time=${time}&duration=${duration}`, config);

	return response.data.data;
});

const MeetingRoomListSlice = createSlice({
	name: "MeetingRoomListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMeetingRoomList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMeetingRoomList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchMeetingRoomList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default MeetingRoomListSlice.reducer;
